export const ProfileUpdateTypeEnum = {
    PROFILE_EDIT_NAME: 'PROFILE_EDIT_NAME',
    PROFILE_EDIT_EMAIL: 'PROFILE_EDIT_EMAIL',
    PROFILE_EDIT_MOBILE: 'PROFILE_EDIT_MOBILE',
    PROFILE_CHANGE_PASSWORD: 'PROFILE_CHANGE_PASSWORD',
    PROFILE_CONFIGURE_MFA: 'PROFILE_CONFIGURE_MFA'
}
